import React from "react";
import Dropzone from "react-dropzone";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
// import queryString from 'query-string';
// import isObject from 'mout/lang/isObject';
import isArray from "mout/lang/isArray";
import remove from "mout/array/remove";
import Input from './Input'
// import MenuItem from '@material-ui/core/MenuItem';

// import RaisedButton from '@material-ui/core/Button';
// import TextField from '@material-ui/core/TextField';
// import Avatar from 'material-ui/Avatar';
import FileIcon from "@material-ui/icons/InsertDriveFile";
// import List from '@material-ui/core/List';

import Grid from "@material-ui/core/Grid";

import Box from "@material-ui/core/Box";
// import mmap from 'mout/object/map';

import IconDelete from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import Spinner from "components/UI/Spinner";
import BlockButton from "components/UI/BlockButton";
// import Avatar from '@material-ui/core/Avatar';
// import ListItem from '@material-ui/core/List';
// import ListItemText from '@material-ui/core/ListItemText';
// import ListItemAvatar from '@material-ui/core/ListItemAvatar';
// import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
const styles = (theme) => {
  // console.log(theme)
  return {
    root: {
      // maxWidth: "1280px",
      // border: '1px #ccc solid',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      margin: "0 0",
      textAlign: 'left',
      // minHeight: '600px',
      '& a': {
        color: theme.palette.primary.main,
        textDecoration: 'none'
      },
      // '&:hover': {
      //   borderColor: theme.palette.text.main,
      // }
    },
    filePreviewWrapper: {
      boxShadow: theme.shadows[1],
      margin: theme.spacing(2),
    }
  }
}
class Upload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      values: [],
      uploadAttributes: [],
      uploading: false,
      complete: false,
    };
  }
  componentDidUpdate(oldProps) {
    if (oldProps.value === undefined && this.props.value !== undefined) {
      this.setState(this.getInitialState(this.props));
      // console.log('YES')
    }
  }
  getInitialState(props) {
    // const initValues = props.value;
    const { value } = props;
    const files = [];
    const values = [];
    let decodedValues = [];
    try {
      // console.log('debug value', value)
      // decodedValues = JSON.parse(initValues);
      decodedValues = JSON.parse(value);
      // console.log(initValues, decodedValues);
    } catch (e) {}
    // console.log('decoded values', decodedValues, isArray(decodedValues))
    if (decodedValues && isArray(decodedValues)) {
      decodedValues.forEach((val) => {
        files.push(val);
        values.push(JSON.stringify(val));
      });
    }
    // console.log('initial values', files, values)
    return {
      files,
      values,
      uploading: false,
      complete: false,
    };
  }
  // setState(state, callback = () => {}){
  //   return new Promise((resolve, reject) => {
  //     super.setState(state, () => {
  //       if (typeof callback != "function") { reject(`${callback} is not a function`)}
  //       else {resolve(callback())}
  //     })
  //   })
  // };
  _upload() {
    const { id, onChange, maxFiles, uploadAttributes } = this.props;
    console.log(this.props)
    var uploadUrl = this.props.url + (this.props.multiple ? "&m=1" : "");

    this.setState({ uploading: true });
    const file = this.state.toUpload[0];
    if (!file) {
      console.log("hum, no file?!");
      return;
    }
    // console.log('the files is', file)
    let reader = new FileReader();

    reader.onload = (e) => {
      var formData = new FormData();
      formData.append("dataURL", reader.result);
      formData.append("fileName", file.name);
      formData.append("fileType", file.type);
      formData.append("fileSize", file.size);
      return fetch(uploadUrl, {
        credentials: "include",
        method: "POST",
        headers: {
          Accept:
          "application/json, application/xml, text/plain, text/html, *.*",
          "X-Requested-With": "XMLHttpRequest", // needed by php api
        },
        body: formData,
      })
      .then((response) => response.json())
      .then((response) => {
        this.setState({ complete: true });
        this.setState({ uploading: false });
        if (response.file) {
          let file = response.file;
          file.isTmp = true;
          let files = this.state.files;
          let values = this.state.values;

          let attributes = {}
          if (uploadAttributes !== null){
            uploadAttributes.map(($$ua, uIdx) => {
              attributes[$$ua.get('id')] = this.state['ua_'+$$ua.get('id')];
              return true;
            })
          }
          file.attributes = attributes;
          // const f = {
          //   id: file,
          //   isTmp: true
          // }
          // const newFile = {}
          // mmap(file, (v, k) => {
          //   newFile[k.toString()] = v;
          // });
          files.push(file);
          // console.log('pre', files)
          values.push(JSON.stringify(file));
          // console.log('MAX', files.length, maxFiles)
          if (files.length > maxFiles) {
            // const fact = (files.length - maxFiles);
            // console.log('fact', fact)
            // files.slice(0, 1);
            files.shift();
            values.shift();
            // console.log('post', files, values)
          }
          // console.log('FINAL', files, values)
          let newState = { files, values }

          if (uploadAttributes !== null){
            uploadAttributes.map(($$ua, uIdx) => {
              newState['ua_'+$$ua.get('id')] = '';
              // console.log('reseting', $$ua.get('id'), newState)
              return true;
            })
          }
          // console.log('new state is', newState)
          this.setState(newState, () => {
            // console.log('CHECK ONCHANGE', values)
            if (onChange)
            onChange("upload", {
              id,
              // value: JSON.stringify(values)
              value: values,
            });
          });
          // console.log('new files', this.state.values)
          // this.props.input.onChange(this.state.values);

          // const { onChange } = this.props;
          // const t = e.target;
          // this.setState({value: t.value}, function() {
          //   if (onChange) onChange('input', {
          //     id: t.getAttribute('id'),
          //     value: t.value
          //   });
          // });
        }
      });
    };
    reader.readAsDataURL(file);

    // });
  }
  onDrop(acceptedFiles) {
    // console.log('onDrop', acceptedFiles)
    this.setState(
      {
        toUpload: acceptedFiles,
      },
      this._upload
    );
  }
  onOpenClick(event) {
    event.preventDefault();
    if (this.state.uploading) return;
    this.dropzone.open();
  }
  onItemClick(event, file) {
    // if (this.props.disabled) return;
    let url;
    if (file.isTmp) url = this.props.tmpUrl + "/" + file.dest;
    else url = this.props.previewUrl + "/" + file.dest;

    if (url !== "") window.open(url);
  }
  onRemoveFile = (event, fileRow) => {
    // console.log('file?', fileRow)
    event.preventDefault();
    event.stopPropagation();
    if (this.props.disabled) return;
    // const { value: originalValue, onChange } = this.props.input;
    const { id, onChange } = this.props;
    const {values: originalValues, files: originalFiles} = this.state;
    const values = [ ...originalValues ];
    const files = [ ...originalFiles ];
    // console.log('pre',values[fileRow], {values, files});
    // delete values[fileRow];
    remove(values, values[fileRow])
    // delete files[fileRow];
    remove(files, files[fileRow])
    // console.log('post', {values, files});
    // onChange(value);
    this.setState({ files, values }, () => {
      // console.log('CHECK ONCHANGE', values)
      if (onChange)
      onChange("upload", {
        id,
        // value: JSON.stringify(values)
        value: values,
      });
    });

  };

  onCancel() {
    console.log("CANCEL CANCEL CANCEL");
  }

  _isImage(file) {
    var r = /((?:\.jpg)|(?:\.png)|(?:\.gif)|(?:\.jpeg)){1}$/g;
    return r.test(file.dest);
  }
  _onUploadAttributeChange = ($$ua, o) => {
    this.setState({['ua_'+$$ua.get('id')]: o.value})
    // console.log($$ua.get('id')+' changed!')
  }
  render() {
    const {
      // acceptedMime,
      // module,
      // previewContainer,
      // onInjectPreview,
      // name,
      // id,
      // value,
      // multiple,
      disabled,
      readOnly,
      classes,
      uploadAttributes,
      variant,
      // ...otherProps
    } = this.props;
    const { files } = this.state;
    // console.log('STATE FILES ARE', files)

    const fileIconStyle = {
      display: "inline-block",
      verticalAlign: "middle",
      marginTop: "-2px",
      marginRight: "5px",
    };
    // console.log({uploadAttributes})
    // console.log('files are', files)
    return (
      <div className={classes.root}>
        <If condition={readOnly !== true && disabled !== true}>
          <Grid
            container
            spacing={2}
            alignItems="center"
            justify="space-around"
            >
            <If condition={!this.state.uploading}>
              <If condition={uploadAttributes !== null}>
                {uploadAttributes.map(($$ua, uIdx) => {
                  return (<Grid key={'ia_'+uIdx} item xs={6}>
                    <Input name={$$ua.get('id')} id={$$ua.get('id')} label={$$ua.get('label')} value={this.state['ua_'+$$ua.get('id')]}  onChange={(kind, o) => {this._onUploadAttributeChange( $$ua, o)}} variant={variant}/>
                  </Grid>)
                })}
              </If>
              <Grid item xs={12}>
                {this.props.label}{" "}
                <BlockButton
                  label="Parcourir"
                  onClick={this.onOpenClick.bind(this)}
                  />
              </Grid>
            </If>
            <If condition={this.state.uploading}>
              <Grid item xs={12}>
                <div
                  style={{
                    width: "auto",
                    display: "inline-block",
                    textAlign: "center",
                  }}
                  >
                  <Spinner
                    size={18}
                    style={{
                      position: "relative",
                      display: "inline-block",
                      width: 18,
                      height: 18,
                      margin: "0 5px 0",
                    }}
                    />
                  Upload en cours
                </div>
              </Grid>
            </If>
            <Choose>
              <When condition={this.state.uploading && this.state.toUpload > 0}>
                <Grid item xs={12}>
                  <span>Uploading {this.state.files.length} file(s)...</span>
                </Grid>
              </When>
            </Choose>
          </Grid>
        </If>
        <If condition={readOnly !== true && disabled !== true}>
          {/*      <Dropzone
            ref={(node) => { this.dropzone = node; }}
            onDrop={this.onDrop.bind(this)}
            accept={acceptedMime}
            className="zone"
            >
            </Dropzone>*/}
            <Dropzone
              ref={(node) => {
                this.dropzone = node;
              }}
              onDrop={this.onDrop.bind(this)}
              onUploadStart={() => {console.log('uploading')}}
              onFileDialogCancel={this.onCancel.bind(this)}
              >
              {({ getRootProps, getInputProps }) => (
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                </div>
              )}
            </Dropzone>
          </If>
          <Choose>
            <When condition={files.length > 0}>
              <Box mt={2}>
                <Grid
                  container
                  spacing={4}
                  alignItems="flex-start"
                  justify="flex-start"
                  >
                  {files.map((file, idx) => {
                    // console.log('istmp', file.isTmp)
                    const imgSrc =
                    (file.isTmp
                      ? this.props.previewTmpUrl
                      : this.props.previewUrl) +
                      "/" +
                      file.dest;
                      const isImage = this._isImage(file);
                      return (
                        <Grid item key={"file_" + idx} xs={12} sm={6} md={4} container className={classes.filePreviewWrapper}>
                          <If condition={isImage}>
                            <Grid item xs={6} container justify="flex-start">
                              <img
                                src={imgSrc}
                                alt="img"
                                width="95%"
                                style={{ verticalAlign: "middle", marginRight: 5 }}
                                />
                            </Grid>
                          </If>
                          <Grid item xs={isImage ? 6 : 12}>
                            <a href={imgSrc} target="_blank">
                              <If condition={!isImage}>
                                <FileIcon style={fileIconStyle} />
                              </If>
                              {file.name}</a> ({Math.round(file.size / 1000 / 1000) + "Mb"})
                              <IconButton size="small" color="secondary" onClick={(e) => {this.onRemoveFile(e, idx)}}><IconDelete size="small"/></IconButton><br />

                              <If condition={uploadAttributes !== null && file.attributes}>
                                {uploadAttributes.map(($$ua, uIdx) => {
                                  return (<Typography variant="body1" key={'at_'+uIdx}>{$$ua.get('label')}: {file.attributes[$$ua.get('id')]}</Typography>)
                                }).toArray()}
                              </If>

                            </Grid>
                          </Grid>
                        );
                      })}
                    </Grid>
                  </Box>
                </When>
                <When
                  condition={
                    files.length < 1 && (readOnly === true || disabled === true)
                  }
                  >
                  <Grid
                    container
                    spacing={0}
                    alignItems="center"
                    justify="space-around"
                    >
                    <Grid item xs={12} md={6} lg={4}>
                      <em
                        style={{
                          width: "100%",
                          display: "block",
                          overflow: "hidden",
                          padding: "20px",
                        }}
                        >
                        Aucun fichier
                      </em>
                    </Grid>
                  </Grid>
                </When>
              </Choose>
            </div>
          );
        }
      }
      export default withStyles(styles)(Upload);



// WEBPACK FOOTER //
// ./src/components/UI/Form/Upload.jsx